<template>
  <div class="w-100 h-100 max-w-3xl mx-auto">
    <p class="text-2xl font-bold">{{ directions.title }}</p>
    <p class="text-lg text-left">{{ directions.description }}</p>

    <div class="max-w-2xl mx-auto p-1 p-md-4">
      <img :src="directions.image" alt="" class="object-contain w-100 h-100" />
    </div>

    <p class="text-lg text-left">
      {{ directions.extraNote }}
    </p>
    <p class="text-lg text-left text-blue-main-toeic">
      Click on <span class="font-bold">Continue</span> to go on.
    </p>
  </div>
</template>

<script>
import writingImg from '@/assets//image/toeic/toeic_exam/WritingTestDirections.png'
import speakingImg from '@/assets//image/toeic/toeic_exam/SpeakingTestDirections.png'

export default {
  computed: {
    isWriting () {
      return this.$route.params.practice_type === 'writing'
    },
    directions () {
      if (this.isWriting) {
        return {
          title: 'Writing Test Directions',
          description:
            'This is the Writing Test. In this test, you will show how well you can use written English. The test includes nine questions and lasts approximately 37 minutes.',
          image: writingImg,
          extraNote:
            'Please write as much as you can in the time allowed. It is important to write clearly and follow the directions.'
        }
      } else {
        return {
          title: 'Speaking Test Directions',
          description:
            'This is the Speaking Test. The test includes eight questions and lasts about fifteen minutes.',
          image: speakingImg,
          extraNote:
            'Please say as much as you can in the time allowed. It is important to speak clearly and follow the directions.'
        }
      }
    }
  }
}
</script>
